// extracted by mini-css-extract-plugin
export var container = "ServiceBox-module--container--lBgXe";
export var imageContainer = "ServiceBox-module--imageContainer--iJAcc";
export var mobileImageContainer = "ServiceBox-module--mobileImageContainer--9ZYQP";
export var noMobileImage = "ServiceBox-module--noMobileImage--ILzGG";
export var tallerBox = "ServiceBox-module--tallerBox--YnDBs";
export var text = "ServiceBox-module--text--1EHvn";
export var textContainer = "ServiceBox-module--textContainer--0fi-u";
export var title = "ServiceBox-module--title--+HLl4";